var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"position-fixed",staticStyle:{"bottom":"0","left":"0","z-index":"999999"}},[_c('b-button',{staticClass:"btn btn-sm btn-danger",on:{"click":_vm.dropuser}},[_vm._v("Cancella Utente")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }